import React, { useEffect, useState } from "react";
import { COLLECTION } from "../../../data/constant";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { Box, Tabs, Tab, Typography } from "@mui/material";

import SalesTab from "./tabs/SalesTab";
import ProductsTab from "./tabs/ProductsTab";
import UsersTab from "./tabs/UsersTab";
import RechargesTab from "./tabs/RechargesTab";
import InventoryTab from "./tabs/InventoryTab";

const Dashboard = () => {
  const [userscount, setUserscount] = useState(0);
  const [totaltransaction, setTotaltransaction] = useState(0);
  const [todaytransaction, setTodaytransaction] = useState(0);
  const [walletamount, setWalletamount] = useState(0);
  const [alpinperday, setAlpinperday] = useState({});
  const [totalRecharge, setTotalRecharge] = useState(0);
  const [todayRecharge, setTodayRecharge] = useState(0);
  const [negativeUsersCount, setNegativeUsersCount] = useState(0);
  const [totalNegativeBalance, setTotalNegativeBalance] = useState(0);

  const [tabIndex, setTabIndex] = useState(0);

  const getTodayRange = () => {
    const now = new Date();
    const start = new Date(now);
    start.setHours(0, 0, 0, 0);
    const end = new Date(now);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  };

  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [startDate, setStartDate] = useState(oneMonthAgo);
  const [endDate, setEndDate] = useState(today);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  /* ---------------- FETCH KPI DATA ---------------- */
  useEffect(() => {
    const fetchData = async () => {
      // Users
      const usersRef = collection(db, COLLECTION.USER);
      const usersSnap = await getDocs(usersRef);
      const usersData = usersSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setUserscount(usersData.length);
      setWalletamount(
        usersData.reduce((acc, u) => acc + (u.walletAmount || 0), 0)
      );

      const negativeUsers = usersData.filter((u) => u.walletAmount < 0);
      setNegativeUsersCount(negativeUsers.length);
      setTotalNegativeBalance(
        negativeUsers.reduce((acc, u) => acc + u.walletAmount, 0)
      );

      // Alpins per day (past 15 days)
      const today = new Date();
      const daysAgo = new Date();
      daysAgo.setDate(today.getDate() - 15);

      const counts = {};
      for (
        let d = new Date(daysAgo);
        d <= today;
        d.setDate(d.getDate() + 1)
      ) {
        counts[d.toISOString().split("T")[0]] = 0;
      }

      usersData.forEach((u) => {
        if (u.createdTimestamp) {
          const dateStr = new Date(u.createdTimestamp * 1000)
            .toISOString()
            .split("T")[0];
          if (dateStr in counts) counts[dateStr] += 1;
        }
      });

      setAlpinperday(counts);

      // Transactions
      const txRef = collection(db, COLLECTION.TRANSACTIONS);
      const txSnap = await getDocs(txRef);
      const txData = txSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((t) => t.transactionAmount);

      const { start, end } = getTodayRange();

      setTodaytransaction(
        txData
          .filter(
            (t) =>
              t.transactionTime.toDate() >= start &&
              t.transactionTime.toDate() <= end
          )
          .reduce((acc, t) => acc + t.transactionAmount, 0)
      );

      setTotaltransaction(
        txData.reduce((acc, t) => acc + t.transactionAmount, 0)
      );

      // Recharges
      const rechargeRef = collection(db, COLLECTION.RECHARGES);
      const rechargeSnap = await getDocs(rechargeRef);
      const rechargeData = rechargeSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((r) => r.message === "PAYMENT_SUCCESS");

      setTotalRecharge(
        rechargeData.reduce((acc, r) => acc + Number(r.amount), 0)
      );

      setTodayRecharge(
        rechargeData
          .filter(
            (r) =>
              r.transactiontime.toDate() >= start &&
              r.transactiontime.toDate() <= end
          )
          .reduce((acc, r) => acc + Number(r.amount), 0)
      );
    };

    fetchData();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        p: 3,
        fontFamily: "Montserrat",
        mt: "-30px",
        mb: "40px",
      }}
    >
      {/* ---------------- TABS ---------------- */}
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          mb: 3,
          fontFamily: "Montserrat",
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{
            sx: {
              backgroundColor: "black",
            },
          }}
          sx={{
            "& .MuiTab-root": {
              fontFamily: "Montserrat",
              textTransform: "none",
              color: "#777",
              fontWeight: 500,
            },
            "& .Mui-selected": {
              color: "black",
              fontWeight: 600,
            },
          }}
        >
          <Tab label="Sales & Transactions" />
          <Tab label="Products" />
          <Tab label="Users" />
          <Tab label="Recharges" />
          <Tab label="Inventory" />
        </Tabs>
      </Box>

      {/* ---------------- TAB PANELS ---------------- */}
      <Box sx={{ fontFamily: "Montserrat" }}>
        {tabIndex === 0 && <SalesTab />}
        {tabIndex === 1 && <ProductsTab />}
        {tabIndex === 2 && <UsersTab />}
        {tabIndex === 3 && <RechargesTab />}
        {tabIndex === 4 && <InventoryTab />}
      </Box>
    </Box>
  );
};

export default Dashboard;
